import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { formatDateLL, objToFormData } from "../../algorithms";
import { nativeStyleEnd, positionStyle } from "../../algorithms/styleDirection";
import { addReply } from "../../API/store/actions/discussion/discussion";
import { paths } from "../../paths/paths";
import { formikSetup } from "../projects/formikValidation";
import Button from "../sharedComponents/buttons/button";
import FileInput from "../sharedComponents/inputs/fileInput";
import TextArea from "../sharedComponents/textarea/textArea";
import { initialValues, validationSchema } from "../tasks/formikValidation";
import RepliesCard from "./repliesCard";

const DiscussionCommentsCard = ({
  userToken,
  comment,
  index,
  length,
  setShowReplays,
  showReplys,
}) => {
  const [replies, setReplies] = useState([]);
  useEffect(() => {
    setReplies(comment?.replies?.length ? [...comment?.replies] : []);
  }, [comment]);
  const userLogged = useSelector((state) => state.login.userData);

  const isFocus = showReplys[comment.id];
  const submit = async (values) => {
    values.CommentId = parseInt(comment.id);
    values.MemberId = parseInt(userLogged?.memberId);
    let data = objToFormData(values);
    values.Description = "";
    let res = await addReply(data, userToken);
    if (res.status <= 206) {
      setReplies([...replies, res?.data]);
    }
  };
  const formik = useFormik(
    formikSetup(initialValues, undefined, validationSchema, "reply", submit)
  );
  const { values, handleChange, setFieldValue, touched, errors, handleSubmit } =
    formik;
  return (
    <div className="p-3 mt-2" style={{}}>
      <div
        id={comment.id}
        className="d-flex justify-content-between w-100"
        style={{}}
      >
        <div className="d-flex align-items-center justify-content-start  col-md-8 ">
          <div
            style={{
              backgroundImage: `url("${paths.MemberPhoto}${comment.memberId}/${comment.memberPhoto}")`,
              width: 40,
              height: 40,
              borderRadius: "50%",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              border: "1px solid white",
            }}
          ></div>
          <p className="my-0 px-2" style={{ fontWeight: "bold" }}>
            {comment.memberName}
          </p>
        </div>
        <div className="d-flex align-items-center justify-content-center col-4">
          <div className="d-flex mb-2">
            <span className="text-muted" style={{ fontSize: 14 }}>
              {formatDateLL(comment.createDate)}
            </span>
          </div>
        </div>
      </div>

      <div className="d-flex  flex-column flex-md-row px-5 align-items-md-center align-items-start justify-content-between">
        <div
          className="col-md-9 col-12"
          style={{
            textAlign: "justify",
            fontSize: 16,
            color: "#444444",
          }}
        >
          {comment.description}
        </div>
        <div
          className="col-md-3 col-12 justify-content-md-center align-items-center justify-content-end d-flex"
          style={{
            color: "#1a73e8",
            fontWeight: "bold",
          }}
        >
          <div
            style={{ cursor: "pointer" }}
            id={comment.id}
            onClick={(e) => {
              setShowReplays({
                [e.currentTarget.id]: !isFocus,
              });
            }}
          >
            الردود
          </div>
          <div
            style={{
              borderRadius: "50%",
              border: "solid 1px grey",
              width: 25,
              height: 25,
            }}
            className="d-flex justify-content-center align-items-center col-1 mx-2"
          >
            <div style={{}} className="text-center">
              {replies?.length}
            </div>
          </div>
        </div>
      </div>
      {showReplys[comment.id] === true ? (
        <div
          className="w-75 container p-2 my-3 bordr"
          style={{
            backgroundColor: "rgba(242, 242, 242, 1)",
            borderRadius: 10,
          }}
        >
          {replies?.map((reply, index) => (
            <RepliesCard
              key={index}
              length={replies.length - 1}
              reply={reply}
              index={index}
            />
          ))}
          <form onSubmit={handleSubmit}>
            <div className="col-11 p-0 my-3 container position-relative bg-white">
              <TextArea
                values={values.Description}
                placeholder={"اضف تعليق ..."}
                style={{ ...nativeStyleEnd("padding", 80) }}
                rows={1}
                name={"Description"}
                onChange={handleChange}
              />
              <div
                style={{ position: "absolute", top: 0, ...positionStyle(0) }}
              >
                <Button
                  content={"اضف"}
                  height={30}
                  styleClass={"solid"}
                  customStyle={{ width: 60 }}
                  type={"submit"}
                />
              </div>
              <div
                style={{
                  position: "absolute",
                  bottom: 7,
                  ...positionStyle(55),
                }}
              >
                <FileInput
                  name={"Attachment"}
                  onChange={(e) => {
                    setFieldValue("Attachment", e.target.files[0]);
                  }}
                  iconName={"paperclip"}
                  iconPrefix={"fas"}
                  size={15}
                  iconColor={values.Attachment ? "#1a73e8" : "#C7C7C9"}
                  backgroundSize={15}
                  backgroundColor={"white"}
                  fileName={" "}
                  containerStyle={""}
                  accept={".gif, .jpg, .png, .doc, .pdf, .xlsx"}
                />
              </div>
            </div>
          </form>
        </div>
      ) : null}
      {index != length ? <hr className="my-3" /> : null}
    </div>
  );
};

export default DiscussionCommentsCard;
